import { BrowserPlatformDevice } from '@amzn/work-spaces-web-client-core-lib';

/**
 * Returns true if the app is running as an installed PWA in standalone mode.
 * Delegates to CoreLib's BrowserPlatformDevice.isPWA() for consistency.
 */
export const isPWA = (): boolean => BrowserPlatformDevice.isPWA();

// Two-column layout needs ~663px content (200px left + 435px right + gap).
// 820px accounts for modal padding to ensure no overflow at any viewport width.
export const NARROW_VIEWPORT_MAX_WIDTH = 820;
